/*!
 * devextreme-vue
 * Version: 23.2.5
 * Build date: Mon Mar 11 2024
 *
 * Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-vue
 */

import * as vue2Stategy from './strategy/vue2/index';
import * as vue3Stategy from './strategy/vue3/index';
import { isVue3 } from './version';
var strategy = isVue3() ? vue3Stategy : vue2Stategy;
export var createComponent = strategy.createComponent;
export var createConfigurationComponent = strategy.createConfigurationComponent;
export var createExtensionComponent = strategy.createExtensionComponent;
